import React from "react"
import PropTypes from "prop-types"
import {Select, Tree} from "antd"
import {Input} from "antd/lib/index";

const Option = Select.Option;
const TreeNode = Tree.TreeNode;
const Search = Input.Search;

export default class LovSelector extends React.Component {

    static propTypes = {
        handleCountryChange: PropTypes.func.isRequired,
        handleTypeChange: PropTypes.func.isRequired,
        handleSelect: PropTypes.func.isRequired,
        data: PropTypes.object.isRequired,
        selectedCountry: PropTypes.string,
        selectedType: PropTypes.string
    };

    state = {
        searchValue: '',
        autoExpandParent: true
    };

    handleSearch = (e) => {
        const value = e.target.value;
        this.setState({
            searchValue: value,
            autoExpandParent: true,
        });
    };

    loop = (data, searchValue) => data.map((lov) => {
        const index = lov.label.indexOf(searchValue);
        const beforeStr = lov.label.substr(0, index);
        const afterStr = lov.label.substr(index + searchValue.length);
        const title = index > -1 ? <span>
          {beforeStr}
            <span style={{color: '#f50'}}>{searchValue}</span>
            {afterStr}
        </span> : <span>{lov.label}</span>;
        if (lov.children) {
            return (
                <TreeNode key={lov.code} title={title}>
                    {this.loop(lov.children)}
                </TreeNode>
            );
        }
        return <TreeNode key={lov.code} title={title}/>;
    });

    render() {
        const {searchValue, autoExpandParent} = this.state;
        const {handleCountryChange, handleTypeChange, data, selectedCountry, selectedType, handleSelect} = this.props;
        const currentCountry = data[selectedCountry] || {};
        const dataKeys = Object.keys(data);
        const type = currentCountry[selectedType] || {};
        const treeNodes = this.loop(type.lovs || [], searchValue);
        const disable = selectedCountry === null;
        return <div>

            <Select placeholder="Select a country" style={{ width: '100%' }} value={selectedCountry}  onChange={handleCountryChange}>
                {dataKeys.map(country => <Option key={country} value={country}>{country}</Option>)}
            </Select>

            <Select style={{ width: '100%', marginTop: 7 }} disabled={disable}  value={selectedType} onChange={handleTypeChange} placeholder="Select a LOV type">
                {Object.keys(currentCountry).map(type => <Option key={type} value={type}>{type}</Option>)}
            </Select>
            <div>
                <Search style={{marginBottom: 8, paddingTop: 7}} disabled={disable} placeholder="Search" onChange={this.handleSearch}/>
            </div>
            <div style={{maxHeight: 700, overflowY: 'auto'}}>
                <Tree
                    onExpand={this.onExpand}
                    expandedKeys={[]}
                    autoExpandParent={autoExpandParent}
                    onSelect={handleSelect}
                >
                    {treeNodes}
                </Tree>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/js/lovs/map/LovSelector.js